import {MultilanguageText} from "../../../core/av-api";
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {translateName} from "../../functions/language.functions";

@Pipe({
  name: 'translateName',
  pure: false
})
export class TranslateNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(value: MultilanguageText): string {
    return translateName(value, this.translate);
  }

}
